/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Fragment, useRef } from "react";
import FlyoutPanelCss from "./FlyoutPanel.css";
import { QuickToolItemContainer } from "containers/quickTools/QuickToolItemContainer";
import { quickToolClickHelper } from "utils/QuickToolsUtils";
import PropTypes from "prop-types";

const FlyoutPanel = props => {
  const { activeVerb, filteredVerbGroups, quickToolsVerbs, shouldUseMobileModernViewer } = props;
  const flyoutPanelRef = useRef();
  const activeVerbGroup =
    activeVerb && filteredVerbGroups && filteredVerbGroups.find(verb => verb.currentActiveVerb === activeVerb);
  const activeVerbs = (activeVerbGroup && activeVerbGroup.verbs) || [];
  const verbDetails = activeVerbs.filter(verb => quickToolsVerbs[verb].show).map(verb => quickToolsVerbs[verb]);

  return (
    <Fragment>
      {verbDetails.length > 1 && (
        <ul ref={flyoutPanelRef} className={FlyoutPanelCss.FlyoutPanelTabList}>
          {verbDetails.map((verb, groupIndex) => {
            const quickToolData = { showCaret: true, verbDetails, currentActiveVerb: verb.verbId, groupIndex };
            return (
              <li key={verb.verbId}>
                <QuickToolItemContainer
                  verbDetails={verbDetails}
                  currentActiveVerb={verb.verbId}
                  groupIndex={groupIndex}
                  quickToolClickHelper={evt => quickToolClickHelper(evt, quickToolData)}
                  shouldUseMobileModernViewer={shouldUseMobileModernViewer}
                />
              </li>
            );
          })}
          {props.children}
        </ul>
      )}
    </Fragment>
  );
};

FlyoutPanel.propTypes = {
  filteredVerbGroups: PropTypes.array,
  activeVerb: PropTypes.string,
  quickToolsVerbs: PropTypes.object,
  shouldUseMobileModernViewer: PropTypes.bool
};

FlyoutPanel.defaultProps = {
  filteredVerbGroups: [],
  activeVerb: "",
  quickToolsVerbs: {},
  shouldUseMobileModernViewer: false
};

export default React.memo(FlyoutPanel);
